var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"thin":true,"title":"<span class='beyond-infinity'>News<span>"}}),_c('ContentRow',{attrs:{"noPaddingTop":true}},[_c('ContentContainer',[_c('Blogs',{attrs:{"archive":true,"filter":_vm.filter}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }